// extracted by mini-css-extract-plugin
module.exports = {"card":"FileCard_card___9SVh","title":"FileCard_title__ScJNP","description":"FileCard_description__OAc0A"};